import { CID } from 'multiformats/cid';
export function toCID(givenCid) {
  var cid = CID.asCID(givenCid);
  if (cid) {
    return cid;
  }
  if (typeof givenCid === 'string') {
    return CID.parse(givenCid);
  }
  if (givenCid instanceof Uint8Array) {
    return CID.decode(givenCid);
  }
  throw new Error("".concat(givenCid, " cannot be converted to a CID"));
}